module.exports = __webpack_public_path__ + "static/img/1-1.152f989.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/home/images/1-1.png
// module id = 944
// module chunks = 30